import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Bloomington",
    route: "#",
    tagline: "Monroe County expedited passport services near Indiana University campus",
    highlights: ["College town coverage", "Serving Ellettsville, Smithville, Spencer"],
    badge: null,
    status: "coming",
  },
  {
    name: "Carmel",
    route: "/cities/carmel",
    tagline: "Hamilton County expedited passport services — 20 minutes from Indianapolis Passport Agency",
    highlights: ["Hamilton County coverage", "Serving Fishers, Westfield, Noblesville"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "Columbus",
    route: "#",
    tagline: "Bartholomew County expedited passport services near Cummins Inc. headquarters",
    highlights: ["South Central Indiana coverage", "Serving Edinburgh, Hope, Seymour"],
    badge: null,
    status: "coming",
  },
  {
    name: "Elkhart",
    route: "#",
    tagline: "Elkhart County expedited passport processing — RV capital of the world",
    highlights: ["North Indiana coverage", "Serving Goshen, Mishawaka, Bristol"],
    badge: null,
    status: "coming",
  },
  {
    name: "Evansville",
    route: "/cities/evansville",
    tagline: "Vanderburgh County expedited passport services on the Ohio River in Southwest Indiana",
    highlights: ["Southwest Indiana coverage", "Serving Newburgh, Mount Vernon, Boonville"],
    badge: null,
    status: "live",
  },
  {
    name: "Fishers",
    route: "#",
    tagline: "Hamilton County expedited passport services in the northern Indianapolis suburbs",
    highlights: ["Hamilton County coverage", "Serving Noblesville, Carmel, Lawrence"],
    badge: null,
    status: "coming",
  },
  {
    name: "Fort Wayne",
    route: "/cities/fort-wayne",
    tagline: "Allen County expedited passport processing for Northeast Indiana travelers",
    highlights: ["Northeast Indiana coverage", "Serving New Haven, Huntington, Columbia City"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "Gary",
    route: "#",
    tagline: "Lake County expedited passport services near Chicago on the Indiana Dunes lakeshore",
    highlights: ["Northwest Indiana coverage", "Serving Hammond, Highland, Merrillville"],
    badge: null,
    status: "coming",
  },
  {
    name: "Goshen",
    route: "#",
    tagline: "Elkhart County expedited passport services near Goshen College",
    highlights: ["North Indiana coverage", "Serving Elkhart, Mishawaka, Nappanee"],
    badge: null,
    status: "coming",
  },
  {
    name: "Greenwood",
    route: "#",
    tagline: "Johnson County expedited passport services south of Indianapolis",
    highlights: ["Central Indiana coverage", "Serving Franklin, Bargersville, Trafalgar"],
    badge: null,
    status: "coming",
  },
  {
    name: "Hammond",
    route: "#",
    tagline: "Lake County expedited passport processing near the Illinois border",
    highlights: ["Northwest Indiana coverage", "Serving Gary, East Chicago, Whiting"],
    badge: null,
    status: "coming",
  },
  {
    name: "Indianapolis",
    route: "/cities/indianapolis",
    tagline: "Marion County expedited passport hub — home of Indiana's only local passport agency",
    highlights: ["Central Indiana coverage", "Serving Carmel, Fishers, Greenwood, Avon"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Kokomo",
    route: "#",
    tagline: "Howard County expedited passport services in North Central Indiana",
    highlights: ["North Central Indiana coverage", "Serving Logansport, Peru, Tipton"],
    badge: null,
    status: "coming",
  },
  {
    name: "Lafayette",
    route: "#",
    tagline: "Tippecanoe County expedited passport services near Purdue University",
    highlights: ["College town coverage", "Serving West Lafayette, Frankfort, Crawfordsville"],
    badge: null,
    status: "coming",
  },
  {
    name: "Merrillville",
    route: "#",
    tagline: "Lake County expedited passport services in Northwest Indiana near Chicago",
    highlights: ["Northwest Indiana coverage", "Serving Hobart, Valparaiso, Portage"],
    badge: null,
    status: "coming",
  },
  {
    name: "Mishawaka",
    route: "#",
    tagline: "St. Joseph County expedited passport processing near South Bend and Notre Dame",
    highlights: ["North Indiana coverage", "Serving South Bend, Granger, Osceola"],
    badge: null,
    status: "coming",
  },
  {
    name: "Muncie",
    route: "#",
    tagline: "Delaware County expedited passport services near Ball State University",
    highlights: ["East Central Indiana coverage", "Serving Anderson, Yorktown, Selma"],
    badge: null,
    status: "coming",
  },
  {
    name: "Noblesville",
    route: "#",
    tagline: "Hamilton County expedited passport services near Ruoff Music Center",
    highlights: ["Hamilton County coverage", "Serving Carmel, Fishers, Westfield"],
    badge: null,
    status: "coming",
  },
  {
    name: "South Bend",
    route: "#",
    tagline: "St. Joseph County expedited passport services near the University of Notre Dame",
    highlights: ["North Indiana coverage", "Serving Mishawaka, Granger, Goshen"],
    badge: null,
    status: "coming",
  },
  {
    name: "Terre Haute",
    route: "#",
    tagline: "Vigo County expedited passport services near Indiana State University on the Wabash River",
    highlights: ["West Central Indiana coverage", "Serving Clinton, Rockville, Sullivan"],
    badge: null,
    status: "coming",
  },
  {
    name: "Valparaiso",
    route: "#",
    tagline: "Porter County expedited passport services near Indiana Dunes National Park",
    highlights: ["Northwest Indiana coverage", "Serving Portage, Chesterton, Portage"],
    badge: null,
    status: "coming",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function IndianaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Indiana Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Indiana Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <> starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span></>
              )}
              {searchQuery && (
                <> matching <span className="font-semibold text-[#1A365D]">&ldquo;{searchQuery}&rdquo;</span></>
              )}
            </p>
            <button
              onClick={() => { setActiveLetter(null); setSearchQuery(""); }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Indiana</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">Coming Soon</span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We are always adding new Indiana locations.
            </p>
            <button
              onClick={() => { setActiveLetter(null); setSearchQuery(""); }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}